import {
  type IGlobalTab,
  type ITab,
  type TabGroup,
  TabGroupName,
} from '@carboncopyco/types/desktop';

const getNextTabIndex = (tabs: ITab[], tabIndex: number) => {
  let nextActiveTabIndex;
  if (tabs[tabIndex + 1]) {
    nextActiveTabIndex = tabIndex + 1;
  } else if (tabs[tabIndex - 1]) {
    nextActiveTabIndex = tabIndex - 1;
  } else {
    nextActiveTabIndex = 0;
  }
  return nextActiveTabIndex;
};

const getTabTitle = (tab: IGlobalTab) => {
  if (tab.group?.mergingOptions?.isDetached) {
    return tab.group.mergingOptions.detachedTitle;
  }
  return tab.title || tab.url;
};

const insertOnIndex = (
  index: number,
  element: IGlobalTab,
  arr: IGlobalTab[]
) => {
  const firstHalf = arr.slice(0, index);
  const lastHalf = arr.slice(index);

  if (index === 0) {
    return [element, ...arr];
  }

  if (index === arr.length) {
    return [...arr, element];
  }

  return [...firstHalf, element, ...lastHalf];
};

const getGroupDefaultValue = (
  id: number,
  name: TabGroupName,
  mergingOptionsKey?: number
): TabGroup => {
  return {
    id,
    name,
    isVisibleIfGroupIsActive: true,
    isVisibleIfGroupIsInactive: true,
    showNonRelatedGroupTabsIfActive: false,
    focusOnCreate: true,
    closeGroupOnClose: true,
    mergingOptions: {
      allowed: true,
      key: mergingOptionsKey ?? id,
      index: 0,
      isDetached: false,
      detachedTitle: '',
    },
  };
};

// TODO: remove this when we switch group.id to string,
// or replace `* [number]` with `${id}-${TabGroupName.DemoEditor}` for example.
// The purpose of it is to distinguish or group tabs with the same id
// e.g. playbook and playbook preview tabs
const generateGroupId = (id: number, groupName?: TabGroupName) => {
  if (groupName === TabGroupName.DemoEditor) {
    return id * 10;
  }
  if (groupName === TabGroupName.PlaybookPreview) {
    return id * 100;
  }
  if (groupName === TabGroupName.TourEditor) {
    return id * 1000;
  }
  if (groupName === TabGroupName.DemoPresent) {
    return id * 10000;
  }
  return id;
};

export {
  getNextTabIndex,
  getTabTitle,
  getGroupDefaultValue,
  insertOnIndex,
  generateGroupId,
};
